<template>
  <div class="attempt-selector mb-4">
    <v-card flat>
      <v-card-text>
        <div class="d-flex align-center">
          <span class="mr-4">{{ $t('job-manager.attempt-selector') }}:</span>

          <!-- Navigation buttons -->
          <v-btn
            icon
            small
            :disabled="selectedAttempt <= 1"
            @click="selectPreviousAttempt"
            class="mr-2"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <!-- Dropdown selector -->
          <v-select
            v-model="selectedAttempt"
            :items="attemptOptions"
            dense
            outlined
            hide-details
            class="attempt-select"
            @change="attemptChanged"
          ></v-select>

          <v-btn
            icon
            small
            :disabled="selectedAttempt >= maxAttempts"
            @click="selectNextAttempt"
            class="ml-2"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AttemptSelector',
  props: {
    value: {
      type: Number,
      default: 1
    },
    maxAttempts: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      selectedAttempt: this.value
    };
  },
  computed: {
    attemptOptions() {
      const options = [];
      for (let i = 1; i <= this.maxAttempts; i++) {
        options.push({
          text: `${this.$t('job-manager.attempt')} ${i}`,
          value: i
        });
      }
      return options;
    }
  },
  watch: {
    value(newVal) {
      this.selectedAttempt = newVal;
    }
  },
  methods: {
    attemptChanged() {
      this.$emit('input', this.selectedAttempt);
    },
    selectPreviousAttempt() {
      if (this.selectedAttempt > 1) {
        this.selectedAttempt--;
        this.attemptChanged();
      }
    },
    selectNextAttempt() {
      if (this.selectedAttempt < this.maxAttempts) {
        this.selectedAttempt++;
        this.attemptChanged();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.attempt-selector {
  width: 100%;
}

.attempt-select {
  max-width: 150px;
}
</style>